// extracted by mini-css-extract-plugin
export default {"size--1":"ow3RG","size--2":"WPRVL","size--3":"iD25C","size--4":"dKwPc","responsive":"fJ5JK","heading":"Qfw66","subheading":"ee2PO"};